import Icon from 'components/Icon';
import {useTooltip} from 'components/Tooltip/hook';
import {AnchorHTMLAttributes, FC} from 'react';
import {useLocale} from 'state/locale';
import {twMerge} from 'tailwind-merge';

export type LinkProps = {
    isOpenInNewTab?: boolean;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

const Link: FC<LinkProps> = ({
    children,
    className,
    isOpenInNewTab,
    ...rest
}) => {
    const {setTooltipRef} = useTooltip();
    const locale = useLocale();

    return (
        <a
            className={twMerge('inline font-semibold', className)}
            ref={(r) => setTooltipRef(r)}
            target={isOpenInNewTab ? '_blank' : undefined}
            {...rest}
        >
            {children}
            {isOpenInNewTab && (
                <Icon
                    className={twMerge(
                        locale === 'ja' && 'mr-1',
                        'ml-1',
                        'inline-block align-middle',
                    )}
                    icon="open_blank"
                    size="base"
                />
            )}
        </a>
    );
};

export default Link;
